import { getItemFromStorage } from "../../helper/storage";
import { authorizedFetch, baseUrl, buildHeaders, getResponseOrThrow } from "./common";

export const apiUpdateEvaluationStatus = (person_id, evaluation_id, status, comment = null, requestedScore = null) => {
  const token = getItemFromStorage("TOKEN");
  const company_id = getItemFromStorage("COMPANY_ID");

  const body = { status };
  if (comment) {
    body.comment = comment;
  }
  if (requestedScore !== null) {
    body.requestedScore = requestedScore;
  }

  return authorizedFetch(
    `${baseUrl}/company/${company_id}/employee/${person_id}/evaluation/${evaluation_id}/review`,
    {
      method: "POST",
      headers: buildHeaders(token),
      body: JSON.stringify(body)
    }
  )
    .then(getResponseOrThrow)
    .catch((error) => Promise.reject(error));
};